import { useCallback } from 'react'
import { NavigateFunction } from 'react-router-dom'
import { toast } from 'react-toastify'
import ROUTES from 'src/constants/routes'
import { getRegisterErrorMessage } from 'src/constants/errorMessages'
import { LOGIN_STATUS } from '../constants'

interface UseRegisterProps {
  registerUser: (payload: any) => Promise<any>
  login: (username: string, senha: string, skipNavigation?: boolean) => Promise<void>
  navigate: NavigateFunction
  setStatusLogin: (status: string) => void
}

export function useRegister({ registerUser, login, navigate, setStatusLogin }: UseRegisterProps) {
  return useCallback(
    async (payload: any) => {
      try {
        const user = await registerUser(payload)
        await login(user.usuario.username, payload.senha, true)
        navigate(ROUTES.AUTH.CONFIRM_PHONE)
      } catch (error: any) {
        setStatusLogin(LOGIN_STATUS.REGISTER_ERROR)
        toast.error(getRegisterErrorMessage(error))
      }
    },
    [login, navigate, registerUser, setStatusLogin]
  )
}
